import { Utilities_Types } from './Utilities.frontend.types'

export namespace PackVerification_Types {
  /**
   * Enumeration mapping the interface keys to the configuration name in storage.
   */
  export enum e_configuration_map {
    require_container_type = 'RequireContainerType',
    require_complete_all_instructions = 'RequireCompleteAllInstructions',
    weight_variance_threshold_percent = 'WeightVarianceThresholdPercent',
    can_continue_closed_sessions = 'canContinueClosedSessions',
    auto_print_reports_on_complete = 'AutoPrintReportsOnComplete'
  }
  /**
   * Interface defining the schema of pack verification configurations.
   */
  export interface i_configuration {
    require_container_type?: boolean;
    require_complete_all_instructions?: boolean;
    weight_variance_threshold_percent?: number;
    can_continue_closed_sessions?: boolean;
    auto_print_reports_on_complete?: boolean;
  }
}

export namespace $frontendTypes {
  export import Utilities =  Utilities_Types;
  export import PackVerification = PackVerification_Types;
}




